import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="">
      <Header />
      <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px]">
        <section className="bg-gradient-to-br from-[#115B9D] to-[#116DAE]">
          <div className="max-w-[1200px] mx-auto px-5 py-10 text-white text-center">
            <h1 className="text-[28px] sm:text-[36px] font-bold leading-tight">Privacy Policy</h1>
            <p className="mt-2 text-blue-100 text-sm sm:text-base max-w-2xl mx-auto">
              Your privacy is important to us. Here's how we protect it.
            </p>
          </div>
        </section>

        <section className="max-w-[1200px] mx-auto px-5 py-10">
          <div className="space-y-10 text-gray-600">
            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">1. Information We Collect</h2>
              <p className="leading-relaxed">
                We collect information you provide directly to us when you create an account, place an order, or contact us.
                This may include your name, email address, shipping address, and payment information.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">2. How We Use Your Information</h2>
              <p className="leading-relaxed">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-5 mt-3 space-y-2">
                <li>Process and deliver your orders for beverage equipment and supplies.</li>
                <li>Communicate with you about your account and purchases.</li>
                <li>Improve our website and customer service.</li>
                <li>Send you marketing communications, if you've opted in to receive them.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">3. Data Security</h2>
              <p className="leading-relaxed">
                We implement industry-standard security measures to protect your personal information. However,
                no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">4. Sharing Your Information</h2>
              <p className="leading-relaxed">
                We do not sell your personal information. We may share your data with trusted partners who help us
                operate our website and process orders (e.g., shipping carriers, payment processors).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">5. Cookies</h2>
              <p className="leading-relaxed">
                Our website uses cookies to enhance your browsing experience and analyze site traffic.
                You can choose to disable cookies in your browser settings.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">6. Your Rights</h2>
              <p className="leading-relaxed">
                You have the right to access, update, or delete your personal information. Please contact us if
                you wish to exercise these rights.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">7. Changes to This Policy</h2>
              <p className="leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page
                with an updated revision date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#116DAE] mb-4">Contact Us</h2>
              <p className="leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us at info@charlessmithassociates.com.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}
